import { Paper, Typography } from '@mui/material';
import Image from '../Image/Image';

import './SimpleProfileCard.scss';

function SimpleProfileCard({
  className, userName, userPictureURL
}) {
  const classNames = `simple-profile-card ${className || ''}`;

  return (
    <Paper
      className={classNames}
      elevation={0}>
      <Image src={userPictureURL} placeholder="profile-img"></Image>
      {userName && (
        <Typography variant="p" component="p" className="user-name">{userName}</Typography>
      )}
    </Paper>
  )
}

export default SimpleProfileCard;
